import React, { useEffect, useState } from 'react';
import Axios from 'axios';

const STAMP_HEIGHT = 14;

const BuildStamp = () => {
    const [buildDate, setBuildDate] = useState(null);

    useEffect(() => {
        Axios.get('/meta.json')
            .then(response => {
                const date = response?.data?.buildDate;
                if (date) setBuildDate(date);
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        if (!buildDate) return undefined;
        const style = document.createElement('style');
        style.textContent = `
            [class*="Sidebar-iconsContainer"],
            [class*="Sidebar-labelsContainer"] {
                padding-bottom: ${STAMP_HEIGHT}px !important;
                box-sizing: border-box !important;
            }
            [data-build-stamp]::selection { color: #fff; background: rgb(86, 90, 101); }
            [data-build-stamp]::-moz-selection { color: #fff; background: rgb(86, 90, 101); }
        `;
        document.head.appendChild(style);
        return () => {
            style.remove();
        };
    }, [buildDate]);

    if (!buildDate) return null;

    return (
        <div
            data-build-stamp
            style={{
                position: 'fixed',
                bottom: 0,
                right: 0,
                width: 60,
                height: STAMP_HEIGHT,
                fontSize: 7,
                lineHeight: `${STAMP_HEIGHT}px`,
                textAlign: 'center',
                whiteSpace: 'nowrap',
                color: 'transparent',
                userSelect: 'text',
                pointerEvents: 'none',
                zIndex: 9999,
                fontFamily: 'monospace'
            }}
        >
            {buildDate}
        </div>
    );
};

export default BuildStamp;
